// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"727":"d14572bd","920":"29990558"}[chunkId] + ".js";
};